import React, { useEffect, useState } from "react";
import MethodGet from "../../config/Service";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
const StateSelect = (props) => {
  const [states, setState] = useState([]);
  useEffect(() => {
    MethodGet("/distribucion/states")
      .then((res) => {
        setState(res.data.states);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const detectarCambiosState = (e) => {
    props.detectarCambiosState(e);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{ marginBottom: 10, width: "100%", marginRight: 18 }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>Estado</InputLabel>
          {props.state_id ? (
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              label='Marcas'
              onChange={detectarCambiosState}
              defaultValue={props.state_id}
            >
              {states &&
                states.map((state) => (
                  <MenuItem key={state.id} value={state.id}>
                    {state.name}
                  </MenuItem>
                ))}
            </Select>
          ) : (
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              label='Marcas'
              onChange={detectarCambiosState}
            >
              {states &&
                states.map((state) => (
                  <MenuItem key={state.id} value={state.id}>
                    {state.name}
                  </MenuItem>
                ))}
            </Select>
          )}
          {/* <FormHelperText>Campo Requerido*</FormHelperText> */}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default StateSelect;
